import React from 'react';
import cssClass from './ModuleSequencingSection.module.css';

const ModuleSequencingSection = () => {
  return (
    <div className={cssClass['component-container']}>
      <div className={cssClass['coming-soon']}>
        <p>Coming Soon</p>
      </div>
    </div>
  );
};

export default ModuleSequencingSection;
